import { getFullFormFields } from './RegisterForm.fields.full'
import type { FieldsConfiguration } from '@molecules/Field/Field.types'

const getRegisterFields = (fromCheckout: boolean): FieldsConfiguration => {
  const fieldsConfig = getFullFormFields()

  if (fromCheckout) {
    const {
      firstName,
      lastName,
      email,
      password,
      repeatPassword,
      dataProtection
    } = fieldsConfig

    return {
      firstName,
      lastName,
      email,
      password,
      repeatPassword,
      dataProtection
    }
  }

  return fieldsConfig
}

export default getRegisterFields
